import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      grid-gap: ", "px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      grid-template-columns: repeat(", ", auto);\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: grid;\n  grid-gap: 8px;\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { ClearedFieldset } from '@scp/ui-shared/theme/resets';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
/* eslint-disable import/no-relative-parent-imports */

import { SwitchGroupBaseOptionResponsive } from '../SwitchGroupBaseOption/SwitchGroupBaseOptionResponsive';
import { E2E_TITLE_SUFFIX } from './constants';
import { GroupLabel, Note } from './baseComponents';
var GridContainer = styled.div(_templateObject(), function (props) {
  return props.size && css(_templateObject2(), 12 / props.size);
}, function (props) {
  return props.gapSize && css(_templateObject3(), props.gapSize);
});
export var SwitchGroupBaseResponsive = function SwitchGroupBaseResponsive(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      value = _ref.value,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      label = _ref.label,
      _ref$labelAsNote = _ref.labelAsNote,
      labelAsNote = _ref$labelAsNote === void 0 ? false : _ref$labelAsNote,
      itemComponent = _ref.itemComponent,
      parentComponent = _ref.parentComponent,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 12 : _ref$size,
      _ref$bottomSpacing = _ref.bottomSpacing,
      bottomSpacing = _ref$bottomSpacing === void 0 ? true : _ref$bottomSpacing,
      defaultExpanded = _ref.defaultExpanded,
      helperText = _ref.helperText,
      itemLabelRenderer = _ref.itemLabelRenderer,
      dataE2e = _ref.dataE2e,
      scrollToSelected = _ref.scrollToSelected;
  var dataE2eTitleLabel = getE2eLabel(label, E2E_TITLE_SUFFIX, dataE2e);
  return React.createElement(ClearedFieldset, null, !!label && React.createElement(GroupLabel, {
    as: labelAsNote ? Note : 'legend',
    "data-e2e": dataE2eTitleLabel
  }, label), helperText && React.createElement(Paragraph, {
    secondary: true
  }, helperText), React.createElement(GridContainer, {
    size: size
  }, items.map(function (item) {
    return React.createElement(SwitchGroupBaseOptionResponsive, {
      key: item.value,
      size: size,
      bottomSpacing: bottomSpacing,
      itemComponent: itemComponent,
      parentComponent: parentComponent,
      itemLabelRenderer: itemLabelRenderer,
      onChange: onChange,
      invalid: invalid,
      name: name,
      disabled: disabled,
      item: item,
      selectedValue: value,
      defaultExpanded: defaultExpanded,
      scrollToSelected: scrollToSelected
    });
  })));
};